import '../../scss/cabinet/main.scss';
import { initAuth } from './auth.js';
import { store, bus } from './state.js';
import { clearSession } from './store.js';
import { formatMoney, formatDateTime } from './utils.js';
import { showToast } from './toast.js';
import { startFlow } from './flow.js';
import { renderOverview } from './sections/overview.js';
import { renderLeads, refreshLeadsBadge } from './sections/leads.js';
import { renderDirectionsSection } from './sections/directions.js';
import { renderFinance } from './sections/finance.js';
import { renderReports } from './sections/reports.js';
import { renderNotifications } from './sections/notifications.js';
import { onLeadPanelChange } from './leadPanel.js';
import { COMPANY_NAME, CONTRACT_NUMBER } from './data.js';

const SECTIONS = {
    overview: { title: 'Обзор', render: renderOverview },
    leads: { title: 'Заявки', render: renderLeads },
    directions: { title: 'Направления и география', render: renderDirectionsSection },
    finance: { title: 'Финансы', render: renderFinance },
    reports: { title: 'Отчёты', render: renderReports },
    notifications: { title: 'Уведомления и CRM', render: renderNotifications }
};

let currentSection = 'overview';

function setSidebarOpen(open) {
    document.querySelector('#cabinet-sidebar').classList.toggle('cabinet-app__sidebar--open', open);
    document.querySelector('#cabinet-sidebar-overlay').classList.toggle('cabinet-app__sidebar-overlay--visible', open);
}

function renderSection(id) {
    currentSection = id;
    const content = document.querySelector('#cabinet-content');
    const title = document.querySelector('#cabinet-section-title');
    const section = SECTIONS[id] || SECTIONS.overview;

    title.textContent = section.title;
    section.render(content);

    document.querySelectorAll('[data-section]').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.section === id);
    });

    setSidebarOpen(false);
}

function refreshHeader() {
    const state = store.get();
    document.querySelector('#header-balance').textContent = formatMoney(state.balance);

    const toggle = document.querySelector('#accept-toggle');
    const statusEl = document.querySelector('#accept-status');
    const canReceive = store.canReceiveLeads();

    toggle.classList.toggle('cabinet-app__accept-toggle--off', !state.acceptingLeads);
    if (!state.acceptingLeads) {
        statusEl.textContent = 'на паузе';
    } else if (!store.isWithinSchedule()) {
        statusEl.textContent = `по расписанию с ${state.schedule.from}`;
    } else {
        statusEl.textContent = 'идёт';
    }

    renderAlerts(state, canReceive);
    refreshLeadsBadge();
    refreshBell();
}

function renderAlerts(state, canReceive) {
    const alertsEl = document.querySelector('#cabinet-alerts');
    const alerts = [];

    if (state.balance < state.balanceThreshold) {
        alerts.push(`
            <div class="cabinet-app__alert">
                <span>Баланс заканчивается</span>
                <button type="button" class="cabinet-app__alert-btn" id="alert-topup">Пополнить</button>
            </div>
        `);
    }
    if (!state.acceptingLeads) {
        alerts.push(`
            <div class="cabinet-app__alert">
                <span>Приём заявок на паузе</span>
                <button type="button" class="cabinet-app__alert-btn" id="alert-resume">Возобновить</button>
            </div>
        `);
    }

    alertsEl.innerHTML = alerts.join('');

    const topupBtn = document.querySelector('#alert-topup');
    if (topupBtn) topupBtn.addEventListener('click', () => document.querySelector('#open-topup').click());

    const resumeBtn = document.querySelector('#alert-resume');
    if (resumeBtn) resumeBtn.addEventListener('click', () => {
        store.update(s => { s.acceptingLeads = true; });
        refreshHeader();
        if (currentSection === 'directions') renderSection('directions');
    });
}

function refreshBell() {
    const state = store.get();
    const count = store.unreadNotificationsCount();
    const countEl = document.querySelector('#bell-count');
    if (count > 0) {
        countEl.textContent = count > 99 ? '99+' : count;
        countEl.hidden = false;
    } else {
        countEl.hidden = true;
    }

    const dropdown = document.querySelector('#bell-dropdown');
    const items = state.notifications.slice(0, 15);
    dropdown.innerHTML = items.length
        ? items.map(n => `
            <div class="cabinet-app__bell-item${n.read ? '' : ' unread'}">
                <div>${n.text}</div>
                <div class="cabinet-app__bell-time">${formatDateTime(n.createdAt)}</div>
            </div>
        `).join('')
        : '<div class="cabinet-app__bell-empty">Уведомлений пока нет</div>';
}

function bindShell() {
    const cabinetLogo = document.querySelector('#cabinet-logo');
    if (cabinetLogo) {
        cabinetLogo.addEventListener('click', e => {
            e.preventDefault();
            renderSection('overview');
            window.scrollTo(0, 0);
        });
    }

    document.querySelectorAll('[data-section]').forEach(btn => {
        btn.addEventListener('click', () => {
            renderSection(btn.dataset.section);
            window.scrollTo(0, 0);
        });
    });

    document.querySelector('#cabinet-burger').addEventListener('click', () => {
        const isOpen = document.querySelector('#cabinet-sidebar').classList.contains('cabinet-app__sidebar--open');
        setSidebarOpen(!isOpen);
    });

    document.querySelector('#cabinet-sidebar-overlay').addEventListener('click', () => {
        setSidebarOpen(false);
    });

    document.querySelector('#accept-toggle').addEventListener('click', () => {
        store.update(s => { s.acceptingLeads = !s.acceptingLeads; });
        refreshHeader();
        if (currentSection === 'directions') renderSection('directions');
    });

    document.querySelector('#bell-toggle').addEventListener('click', () => {
        const dropdown = document.querySelector('#bell-dropdown');
        dropdown.hidden = !dropdown.hidden;
        document.querySelector('#avatar-dropdown').hidden = true;
        if (!dropdown.hidden) {
            store.markNotificationsRead();
            refreshBell();
        }
    });

    const avatarDropdown = document.querySelector('#avatar-dropdown');
    avatarDropdown.querySelector('.cabinet-app__avatar-company').textContent = COMPANY_NAME;
    avatarDropdown.querySelector('.cabinet-app__avatar-meta').textContent = `Логин: demo · договор № ${CONTRACT_NUMBER}`;

    document.querySelector('#avatar-toggle').addEventListener('click', () => {
        avatarDropdown.hidden = !avatarDropdown.hidden;
        document.querySelector('#bell-dropdown').hidden = true;
    });

    document.addEventListener('click', e => {
        if (!e.target.closest('.cabinet-app__bell-wrap')) document.querySelector('#bell-dropdown').hidden = true;
        if (!e.target.closest('.cabinet-app__avatar-wrap')) document.querySelector('#avatar-dropdown').hidden = true;
    });

    document.querySelector('#logout-btn').addEventListener('click', () => {
        clearSession();
        window.location.reload();
    });

    document.querySelector('#manager-contact-link').addEventListener('click', () => {
        window.location.href = '/lead-generation.html#directions';
    });

    document.querySelector('#open-topup').addEventListener('click', openTopupModal);

    document.querySelectorAll('[data-close-modal]').forEach(el => {
        el.addEventListener('click', () => {
            el.closest('.cab-modal').hidden = true;
        });
    });

    document.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.cab-modal').forEach(m => { m.hidden = true; });
        document.querySelector('#bell-dropdown').hidden = true;
        document.querySelector('#avatar-dropdown').hidden = true;
        setSidebarOpen(false);
    });
}

function openTopupModal() {
    const modal = document.querySelector('#topup-modal');
    const amounts = document.querySelector('#topup-amounts');
    const status = document.querySelector('#topup-status');
    status.textContent = '';

    const values = [10000, 20000, 30000, 50000, 100000];
    let selected = values[1];

    function renderAmounts() {
        amounts.innerHTML = values.map(v => `
            <button type="button" class="cab-modal__amount${v === selected ? ' active' : ''}" data-amount="${v}">${v.toLocaleString('ru-RU')} ₽</button>
        `).join('');
        amounts.querySelectorAll('[data-amount]').forEach(btn => {
            btn.addEventListener('click', () => {
                selected = Number(btn.dataset.amount);
                renderAmounts();
            });
        });
    }
    renderAmounts();

    document.querySelector('#topup-card').onclick = () => {
        status.textContent = 'Проводим платёж…';
        setTimeout(() => {
            store.topUp(selected, 'Картой');
            status.textContent = `Баланс пополнен на ${formatMoney(selected)}`;
            refreshHeader();
            if (SECTIONS[currentSection]) SECTIONS[currentSection].render(document.querySelector('#cabinet-content'));
            setTimeout(() => { modal.hidden = true; }, 900);
        }, 1200);
    };

    document.querySelector('#topup-invoice').onclick = () => {
        store.topUp(0, 'Счёт для юрлица');
        store.update(s => { s.operations.shift(); });
        status.textContent = 'Счёт отправлен на почту';
    };

    modal.hidden = false;
}

function startClock() {
    setInterval(() => {
        if (currentSection === 'overview' || currentSection === 'directions') {
            refreshHeader();
        }
    }, 30000);
}

function boot() {
    document.querySelector('#auth-screen').hidden = true;
    document.querySelector('#cabinet-app').hidden = false;

    bindShell();
    renderSection('overview');
    refreshHeader();
    startFlow();
    startClock();

    bus.addEventListener('change', () => {
        refreshHeader();
    });

    bus.addEventListener('lead:new', () => {
        if (SECTIONS[currentSection]) SECTIONS[currentSection].render(document.querySelector('#cabinet-content'));
    });

    bus.addEventListener('lead:dispute-resolved', () => {
        if (SECTIONS[currentSection]) SECTIONS[currentSection].render(document.querySelector('#cabinet-content'));
    });

    onLeadPanelChange(() => {
        refreshHeader();
        if (SECTIONS[currentSection]) SECTIONS[currentSection].render(document.querySelector('#cabinet-content'));
    });

    document.addEventListener('cabinet:header-refresh', refreshHeader);
}

function init() {
    initAuth({ onSuccess: boot });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
